<div class="audit-container">
  <div class="search">
    <form [formGroup]="search">
      <select style="margin: 0 10px 50px 0; width: 120px;" formControlName="select">
        <option *ngFor="let i of displayedColumns" [value]="i">{{i}}</option>
      </select>
      <input style="width: 300px" type="text" formControlName="result"
        placeholder="{{(placeHolder) ? 'Escribe para buscar por '+ placeHolder: 'Seleccione para poder buscar'}}"
        id="searcher">
    </form>
  </div>
  <table mat-table [dataSource]="listAudit" aria-label="Tabla de auditoría">
    <ng-container matColumnDef="IdRequest">
      <th mat-header-cell *matHeaderCellDef> Nº Request </th>
      <td mat-cell *matCellDef="let element"> {{element.IdRequest}} </td>
    </ng-container>
    <ng-container matColumnDef="IdUsuario">
      <th mat-header-cell *matHeaderCellDef> Id Usuario </th>
      <td mat-cell *matCellDef="let element"> {{element.IdUsuario}} </td>
    </ng-container>
    <ng-container matColumnDef="ExecutionId">
      <th mat-header-cell *matHeaderCellDef> Execution id </th>
      <td mat-cell *matCellDef="let element"> {{element.ExecutionId}} </td>
    </ng-container>
    <ng-container matColumnDef="EXEC_UUID">
      <th mat-header-cell *matHeaderCellDef> Execution UID </th>
      <td mat-cell *matCellDef="let element"> {{element.EXEC_UUID}} </td>
    </ng-container>
    <ng-container matColumnDef="Robot">
      <th mat-header-cell *matHeaderCellDef> Robot </th>
      <td mat-cell *matCellDef="let element"> {{element.Robot}} </td>
    </ng-container>

    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
    </ng-container>

    <ng-container matColumnDef="ResponseCode">
      <th mat-header-cell *matHeaderCellDef> Respuesta Eurobits </th>
      <td mat-cell *matCellDef="let element"> {{element.ResponseCode}} </td>
    </ng-container>

    <ng-container matColumnDef="StartTime">
      <th mat-header-cell *matHeaderCellDef> Start time </th>
      <td mat-cell *matCellDef="let element"> {{element.StartTime}} </td>
    </ng-container>

    <ng-container matColumnDef="EndTime">
      <th mat-header-cell *matHeaderCellDef> End time </th>
      <td mat-cell *matCellDef="let element"> {{element.EndTime}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
